interface MenuItem {
  title: string
  href?: string
  hasMegamenu?: boolean
  colclass?: string
  submenu?: Array<any>
  hasDropdown?: boolean
  megamenuClass?: string
  megamenuColumns?: Array<any>
}

export const menuItems: Array<MenuItem> = [
  {
    title: "Hjem",
    href: "/company",
  },
  {
    title: 'Produkter',
    hasDropdown: true,
    submenu: [
      { href: "/company/product/drill", label: "Boretårn" },
      { href: "/company/product/boring", label: "Borerigger" },
      { href: "/company/product/addon", label: "Påbyggere" },
    ],
  },
  {
    title: 'Tjenester',
    hasDropdown: true,
    submenu: [
      { href: "/company/service/process", label: "Prosess" },
      { href: "/company/service/agro", label: "Landbruk" },
      { href: "/company/service/special", label: "Spesial" },
    ],
  },
  {
    title: 'IoT',
    hasDropdown: true,
    submenu: [
      { href: "/company/iot/offer", label: "Hva kan vi tilby?" },
      { href: "/company/iot/implementation", label: "Implmentasjon" },
      { href: "/company/iot/get-started", label: "Kom i gang" },
    ],
  },
  { title: 'Prosjekter', href: "/company/projects" },
  { title: 'Referanser', href: "/company/references" },
  {
    title: 'Om oss',
    hasDropdown: true,
    submenu: [
      { href: '/company/company/about', label: 'Om selskapet' },
      { href: '/company/company/blog', label: 'Nyheter' },
      { href: '/company/company/team', label: 'Ansatte' },
      { href: '/company/company/contact', label: 'Kontakt oss' },
    ],
  },
  /*
  {
    title: "Elements",
    hasMegamenu: true,
    colclass: "col-lg-3 single-mega-item",
    megamenuColumns: [
      [
        { href: "/button", label: "Button" },
        { href: "/service", label: "Service" },
        { href: "/counter", label: "Counter" },
        { href: "/progressbar", label: "Progressbar" },
        { href: "/accordion", label: "Accordion" },
        { href: "/social-share", label: "Social Share" },
        { href: "/blog-grid", label: "Blog Grid" },
      ],
      [
        { href: "/team", label: "Team" },
        { href: "/portfolio", label: "Portfolio" },
        { href: "/testimonial", label: "Testimonial" },
        { href: "/timeline", label: "Timeline" },
        { href: "/tab", label: "Tab" },
        { href: "/pricing", label: "Pricing" },
        { href: "/split", label: "Split Section" },
      ],
      [
        { href: "/call-to-action", label: "Call To Action" },
        { href: "/video", label: "Video" },
        { href: "/gallery", label: "Gallery" },
        { href: "/contact", label: "Contact" },
        { href: "/brand", label: "Brand" },
        { href: "/portfolio", label: "Portfolio" },
        { href: "/error", label: "404" },
      ],
      [
        { href: "/advance-tab", label: "Advance Tab", badge: "Hot" },
        { href: "/brand-carouse", label: "Brand Carousel", badge: "Hot" },
        { href: "/advance-pricing", label: "Advance Pricing", badge: "Hot" },
        { href: "/portfolio-details/1", label: "Portfolio Details" },
        { href: "/blog-details/1", label: "Blog Details" },
        { href: "/privacy-policy", label: "Privacy Policy", badge: "Hot" },
        { href: "/login", label: "Profile", badge: "Hot" },
      ],
    ],
  },
  {
    title: "Blog",
    hasDropdown: true,
    megamenuClass: '',
    submenu: [
      { href: "/blog-grid", label: "Blog Grid" },
      { href: "/blog-grid-sidebar", label: "Blog Grid Sidebar" },
      { href: "/blog-list-view", label: "Blog List View" },
      { href: "/blog-list-sidebar", label: "Blog List View Sidebar" },
      { href: "/blog-details/1", label: "Blog Details" },
    ],
  },
  {
    title: "Portfolio",
    hasDropdown: true,
    submenu: [
      { href: "/portfolio", label: "Portfolio Default" },
      { href: "/portfolio-three-column", label: "Portfolio Three Column" },
      { href: "/portfolio-full-width", label: "Portfolio Full Width" },
      { href: "/portfolio-grid-layout", label: "Portfolio Grid Layout" },
      { href: "/portfolio-box-layout", label: "Portfolio Box Layout" },
      { href: "/portfolio-details/1", label: "Portfolio Details" },
    ],
  },
  */
];
